"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignType = void 0;
exports.CampaignType = {
    CAMPAIGN: 'Campaign',
    SERIES: 'Series',
    COLLECTION: 'Collection',
};
exports.default = exports.CampaignType;
